import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import History from "../../components/OrderGrid/History/History"
import Button from '../../components/UI/Button/Button'
import DatePicker from '../../components/UI/DatePicker/DatePicker'
import Input from '../../components/UI/Input/Input'
import Modal from '../../components/UI/Modal/Modal'
import Search from '../../components/UI/Search/Search'
import Select from '../../components/UI/Select/Select'
import Spinner from "../../components/UI/Spinner/Spinner"
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'
import Table from "../../components/UI/Table/Table"

const FranchiseOrders = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [franchiseOrders, setFranchiseOrders] = React.useState([])
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [loading, setLoading] = React.useState(false)
    const [tableData, setTableData] = React.useState([])
    const [searchParams, setSearchParams] = React.useState({
        franchiseOrderNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شماره سفارش'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        },
        courierTrackNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شناسه سفارش دهنده'
            },
            validation: {
            },
            errorMessage: '',
            valid: true,
            value: ''
        },
    })
    const [franchiseOrderState, setOrderState] = React.useState('')
    const [franchiseOrderStates, setOrderStates] = React.useState([
        {
            value: 'R',
            label: 'ثبت شده'
        },
        {
            value: 'F',
            label: 'نهایی شده'
        }
    ])
    const [modalContent, setModalContent] = React.useState('')
    const [kiosks, setKiosks] = React.useState([])
    const [kiosk, setKiosk] = React.useState('')
    const [units, setUnits] = React.useState([])
    const [unit, setUnit] = React.useState('')
    const [lockerTypes, setLockerTypes] = React.useState([])
    const [lockerType, setLockerType] = React.useState('')
    const childRef = React.useRef();

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        const search = searchParams
        for (let key in search) {
            search[key].value = ''
        }
        setSearchParams(search)
        setOrderState('')
        setOrderState('')
        const fromDate = new URLSearchParams(window.location.search).get("from")
        const toDate = new URLSearchParams(window.location.search).get("to")
        const state = new URLSearchParams(window.location.search).get("state")
        if (state != null && state != '') {
            const orSt = franchiseOrderStates.filter(st => st.value == state)
            if (orSt != null && orSt.length != 0) {
                setOrderState(orSt[0])
            }
        }
        setFrom(fromDate)
        setTo(toDate)
        var raw = JSON.stringify({
            "kiosk": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/kiosks/getFranchiseKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setKiosks(result.kiosks)
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "unit": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setUnits(result.units)
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "lockerType": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/lockertypes/getLockerTypes'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setLockerTypes(result.lockerTypes)
                }
            })
            .catch(error => console.log(error))
    }, [])

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = isRefresh ? {
            filter: {}, "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        } : JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "franchiseOrderNumber": searchParams['franchiseOrderNumber'].value !== '' ? "%" + searchParams['franchiseOrderNumber'].value + "%" : null,
                "courierTrackNumber": searchParams['courierTrackNumber'].value !== '' ? "%" + searchParams['courierTrackNumber'].value + "%" : null,
                "franchiseOrderState": franchiseOrderState != null && franchiseOrderState != '' ? franchiseOrderState.value : null,
                "lockerType": lockerType != null && lockerType != '' ? lockerType.value : null,
                "kiosk": kiosk != null && kiosk != '' ? kiosk.value : null,
                "unitId": unit != null && unit != '' ? unit.value : null
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/searchFranchiseOrdersByFilter'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.orders)
                    pushData(newList)
                    setFranchiseOrders(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }

    const showHistoriesHandler = (id) => {
        var info = {
            "order": {
                "id": id,
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderInfo'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0' && result.order.histories != null) {
                    const historyContent = result.order.histories != null && result.order.histories.length != 0 ? result.order.histories.map(h => {
                        return <History history={h} />
                    }) : ''
                    setModalContent(historyContent);
                    childRef.current.openModal()
                }
                setLoading(false)
            })
            .catch(error => setLoading(false))
    }

    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'orderNumber',
                header: 'شمازه سفارش',
                align: 'center',
            },
            {
                accessorKey: 'registerDate',
                header: 'تاریخ ثبت',
                align: 'center',
            },
            {
                accessorKey: 'startDate',
                header: 'از تاریخ',
                align: 'center',
            },
            {
                accessorKey: 'endDate',
                header: 'تا تاریخ',
                align: 'center',
            },
            {
                accessorKey: 'unitName',
                header: 'سفارش دهنده',
                align: 'center',
            },
            {
                accessorKey: 'courierTrackNumber',
                header: 'شناسه سفارش دهنده',
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                orderNumber: d.orderNumber,
                registerDate: d.registerDate,
                startDate: d.startDate,
                endDate: d.endDate,
                unitName: !!d.unit ? d.unit.unitName : '-',
                courierTrackNumber: d.courierTrackNumber,
                subRows: [
                    { header: 'از ساعت', value: d.startTime },
                    { header: 'تا ساعت', value: d.endTime },
                    { header: 'سریال باکس', value: !!d.locker ? d.locker.serial : '' },
                    { header: 'نام باکس', value: !!d.kiosk ? d.kiosk.description : '' },
                    { header: 'هزینه باکس', value: !!d.lockerAmount ? d.lockerAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-' },
                    { header: 'مالیات', value: !!d.taxAmount ? d.taxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-' },
                    { header: 'هزینه نهایی', value: !!d.finalAmount ? d.finalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-' },
                ],
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        buttons.push({ id: 1, text: 'مشاهده تاریخچه', clicked: showHistoriesHandler });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }

    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }

    const changeOrderState = selectedOption => {
        setOrderState(selectedOption)
    }

    const refresh = (event) => {
        setFrom('')
        setTo('')
        setKiosk('')
        setUnit('')
        setLockerType('')
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setOrderState('')
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }
    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }

    const afterCloseModal = (event) => {
    }

    const exportToCSV = (event) => {
        var raw = JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "franchiseOrderNumber": searchParams['franchiseOrderNumber'].value !== '' ? "%" + searchParams['franchiseOrderNumber'].value + "%" : null,
                "courierTrackNumber": searchParams['courierTrackNumber'].value !== '' ? "%" + searchParams['courierTrackNumber'].value + "%" : null,
                "franchiseOrderState": franchiseOrderState != null && franchiseOrderState != '' ? franchiseOrderState.value : null,
                "lockerType": lockerType != null && lockerType != '' ? lockerType.value : null,
                "kiosk": kiosk != null && kiosk != '' ? kiosk.value : null,
                "unitId": unit != null && unit != '' ? unit.value : null
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/searchFranchiseOrdersByFilter'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrder = []
                    let count = 0
                    const franchiseOrder = result.orders.map(o => {

                        count++
                        exportOrder.push({
                            'ردیف': count,
                            'شماره سفارش': o.franchiseOrderNumber,
                            'شناسه سفارش دهنده': o.courierTrackNumber,
                            'تاریخ ثبت': o.registerDate,
                            'نام ثبت کننده': o.unit != null ? o.unit.unitName : '',
                            "تاریخ شروع": o.startDate,
                            "ساعت شروع": o.startTime,
                            "تاریخ پایان": o.endDate,
                            "ساعت پایان": o.endTime,
                            "هزینه باکس": o.lockerAmount,
                            "مالیات": o.taxAmount,
                            "هزینه نهایی": o.finalAmount,
                            'دلیل کنسلی': o.cancelReason
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrder);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'FranchiseOrders' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const changeKiosk = selectedOption => {
        setKiosk(selectedOption)
    }

    const changeUnit = selectedOption => {
        setUnit(selectedOption)
    }

    const changeLockerType = selectedOption => {
        setLockerType(selectedOption)
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })

    const kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }

    const unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }

    const lockerTypeList = []
    if (lockerTypes != null && lockerTypes.length != 0) {
        lockerTypes.map(z => {
            lockerTypeList.push({
                value: z.id,
                label: z.description
            })
        })
    }

    form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr">
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
            <div className="col-3 full-small">
                <DatePicker change={changeFromDate} value={from} placeHolder="از تاریخ" />
            </div>
            <div className="col-3 full-small">
                <DatePicker change={changeToDate} value={to} placeHolder="تا تاریخ" />
            </div>
            <Select
                name="form-field-name"
                value={franchiseOrderState}
                placeholder="وضعیت سفارش"
                options={franchiseOrderStates}
                onChange={changeOrderState}
                col='3'
            />
            <Select
                name="form-field-name"
                value={kiosk}
                placeholder="لاکر"
                options={kioskList}
                onChange={changeKiosk}
                col="3"
            />
            <Select
                name="form-field-name"
                value={unit}
                placeholder="حساب"
                options={unitList}
                onChange={changeUnit}
                col="3"
            />
            <Select
                name="form-field-name"
                value={lockerType}
                placeholder="نوع باکس"
                options={lockerTypeList}
                onChange={changeLockerType}
                col="3"
            />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 ord-small-btns">
                <Button btnType="search-btn" clicked={search}>
                    <span className="tab-color">
                        جستجو
                    </span>
                </Button>
            </div>
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-franchiseOrders">
            {loading ? <Spinner /> : ''}
            <Search class="orders-search" form={form} />
            <div className="row justify-content-center">
                {rerender ?
                    // <Spinner />
                    <Table pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                    :
                    <Table pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                }
            </div>
            <Modal
                content={modalContent}
                ref={childRef}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
        </div>
    )
}
export default FranchiseOrders